import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CloseButton } from '../CloseButton';
import { Tooltip } from '../Tooltip';
import moduleStyles from '@dtsl/css-tag/dist/index.module.css';

// eslint-disable-next-line react/display-name
const Tag = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    label,
    color,
    closable,
    onClose,
    disabled,
    className,
    border,
    icon,
    dataTestId,
    showTooltip,
    iconAlone,
    styles,
    iconPosition,
    labelStyles
  } = props;
  const [contentToolTip, showContentToolTip] = useState(false);
  const tagContentRef = useRef(null);
  const tagClass = classNames({
    [moduleStyles['sib-tag']]: true,
    [moduleStyles['sib-tag-border']]: border,
    [`${moduleStyles[`sib-tag-${color}`]}`]: !!color,
    [moduleStyles['sib-tag-icon-alone']]: iconAlone,
    [className]: !!className
  });
  const handleClose = event => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClose(event);
  };
  useEffect(() => {
    if (showTooltip) {
      if (tagContentRef && tagContentRef.current) {
        const {
          offsetWidth,
          scrollWidth
        } = tagContentRef.current;
        if (offsetWidth < scrollWidth) {
          showContentToolTip(true);
        }
      } else {
        showContentToolTip(false);
      }
    } else {
      contentToolTip && showContentToolTip(false);
    }
  }, [showTooltip]);
  const tag = /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: tagClass,
    style: {
      ...styles
    }
  }, icon && iconPosition === 'left' ? /*#__PURE__*/React.cloneElement(icon, {
    className: moduleStyles['sib-tag__icon-left']
  }) : null, !iconAlone && /*#__PURE__*/React.createElement("span", {
    "data-testid": dataTestId ? dataTestId : null,
    className: moduleStyles['label'],
    ref: tagContentRef,
    style: {
      ...labelStyles
    }
  }, label), icon && iconPosition === 'right' ? /*#__PURE__*/React.cloneElement(icon, {
    className: moduleStyles['sib-tag__icon-right']
  }) : null, closable && !iconAlone && /*#__PURE__*/React.createElement(CloseButton, {
    className: moduleStyles['sib-tag-cross'],
    size: "small",
    disabled: disabled,
    onClick: handleClose
  }));
  if (contentToolTip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      text: label
    }, tag);
  } else {
    return tag;
  }
});
Tag.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  closable: PropTypes.bool,
  iconAlone: PropTypes.bool,
  onClose: PropTypes.func,
  disabled: PropTypes.bool,
  border: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.oneOf(['', 'blue', 'green', 'orange', 'red', 'gold', 'pink', 'mint', 'white']),
  icon: PropTypes.node,
  dataTestId: PropTypes.string,
  showTooltip: PropTypes.bool,
  styles: PropTypes.object,
  labelStyles: PropTypes.object
};
Tag.defaultProps = {
  label: '',
  className: '',
  color: '',
  closable: false,
  disabled: false,
  onClose: () => {},
  border: false,
  icon: null,
  showTooltip: false,
  iconAlone: false,
  styles: {},
  iconPosition: 'left',
  labelStyles: {}
};
export default Tag;